
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GeneratedEmailResponse, GenerateEarlyBirdInvoiceEmail } from '../api/dtos';

const getData = (response?: SWRResponse<GeneratedEmailResponse, GeneratedEmailResponse>) => response?.data?.result;

const getError = (response?: SWRResponse<GeneratedEmailResponse, GeneratedEmailResponse>) => (response?.error ?? response?.data);

const getAdditionalState = (response?: SWRResponse<GeneratedEmailResponse, GeneratedEmailResponse>) => ({
    invoice: response?.data?.result
});

export const useEarlyBirdInvoice = (reg?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {

        return () => {
            
            return new GenerateEarlyBirdInvoiceEmail({registrationId: reg});
        };
    }, [reg])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useEarlyBirdInvoice;

